import { Fragment, useEffect } from "react";

import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Row,
  Form,
  FormFeedback,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";

import React, { useState, useRef } from "react";
import Select from "react-select";
import { SuccessNotify, ErrorNotify } from "../../shared/Alert";
import {
  createChecklist,
  updateChecklist,
  getQuestionDetail,
  getReferencelists,
  getArealists,
  getTopiclists,
  getServiceCodeList,
  getMandatoryServiceCodeList,
  createQuestion,
  updateQuestion,
} from "../../helpers/backend_helper";
import classnames from "classnames";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";
import { showLoading } from "react-global-loading";

const SearchableSelect = ({ field, options, placeholder, validation, selectStyles }) => (
    <Select
      inputId={field}
      classNamePrefix="checklist-question-select"
      options={options}
      value={options.find((option) => String(option.value) === String(validation.values[field])) || null}
      onChange={(option) =>
        validation.setFieldValue(field, option?.value || "")
      }
      onBlur={() => validation.setFieldTouched(field, true)}
      placeholder={placeholder}
      isClearable
      isSearchable
      menuPortalTarget={typeof document !== "undefined" ? document.body : null}
      menuPosition="fixed"
      styles={selectStyles}
    />
  );

const QuestionDetail = (props) => {
  const addAnother = useRef(false);
  const questionInput = useRef(null);
  const [isSaving, setIsSaving] = useState(false);
  const [savedReference, setSavedReference] = useState("");
  const serviceCodeOptionLabel = (serviceCode) =>
    [serviceCode.name, serviceCode.description].filter(Boolean).join(" — ");

  const [areaList, setAreaList] = useState([]);
  const [topicList, setTopicList] = useState([]);
  const [serviceCodeList, setServiceCodeList] = useState([]);
  const [mandatoryServiceCodeList, setMandatoryServiceCodeList] = useState([]);

  const [formData, setFormData] = useState({
    id: 0,
    checkListId: 0,
    name: "",
    referenceNo: "",
    areaId: "",
    topicId: "",
    serviceCodeId: "",
    mustServiceCodeId: "",
    description: "",
  });

  useEffect(() => {
    showLoading(true);

    getArealists()
      .then((res) => {
        if (res.data) {
          setAreaList(res.data);
        }
      })
      .catch((err) => {
        ErrorNotify("Error occured while fetching data");
      });

    getTopiclists()
      .then((res) => {
        if (res.data) {
          setTopicList(res.data);
        }
      })
      .catch((err) => {
        ErrorNotify("Error occured while fetching data");
      });

    getServiceCodeList()
      .then((res) => {
        if (res.data) {
          setServiceCodeList(res.data);
        }
      })
      .catch((err) => {
        ErrorNotify("Error occured while fetching data");
      });

    getMandatoryServiceCodeList()
      .then((res) => {
        if (res.data) {
          setMandatoryServiceCodeList(res.data);
        }
      })
      .catch((err) => {
        ErrorNotify("Error occured while fetching data");
      });

    if (props.detailId && props.detailId > 0) {
      getQuestionDetail(props.detailId).then((res) => {
        showLoading(false);
        if (res.status) {
          setFormData({
            id: res.data.id || 0,
            checkListId: res.data.checkListId || props.checklistId || 0,
            name: res.data.question || "",
            referenceNo: res.data.referenceNo || "",
            areaId: res.data.areaId || "",
            topicId: res.data.topicId || "",
            serviceCodeId: res.data.serviceCodeId || "",
            mustServiceCodeId: res.data.mandatoryServiceId || "",
            description: res.data.description || "",
          });
        } else {
          ErrorNotify(res.message);
        }
      });
    }

    showLoading(false);
  }, []);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      id: formData.id || 0,
      checkListId: formData.checkListId || 0,
      name: formData.name || "",
      referenceNo: formData.referenceNo || "",
      areaId: formData.areaId || "",
      topicId: formData.topicId || "",
      serviceCodeId: formData.serviceCodeId || "",
      mustServiceCodeId: formData.mustServiceCodeId || "",
      description: formData.description || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Question for the Checklist"),

    }),
    onSubmit: (values) => {
      if (isSaving) return;
      setIsSaving(true);

      showLoading(true);

      var _data = {
        question: values.name,
        checklistId: Number(props.checklistId),
        referenceNo: values.referenceNo,
        areaId: values.areaId ? Number(values.areaId) : null,
        topicId: values.topicId ? Number(values.topicId) : null,
        serviceCodeId: values.serviceCodeId ? Number(values.serviceCodeId) : null,
        mandatoryServiceId: values.mustServiceCodeId ? Number(values.mustServiceCodeId) : null,
        description: values.description,
      };

      if (values.id == 0) {
        createQuestion(_data)
          .then((res) => {
            showLoading(false);
            if (res.status) {
              setSavedReference(res.data?.referenceNo || "");
              SuccessNotify("Question saved successfully");
              if (addAnother.current) {
                const nextValues = {
                  ...values, id: 0, name: "", referenceNo: "", description: "",
                };
                setFormData(nextValues);
                validation.resetForm({ values: nextValues });
                props.onSaved?.();
                questionInput.current?.focus();
              } else {
                props.closeAction?.();
              }
            } else {
              ErrorNotify(res.message);
            }
          })
          .catch((err) => {
            showLoading(false);
            console.log(err);
            ErrorNotify("failed");
          })
          .finally(() => setIsSaving(false));
      } else {
        _data.id = values.id;

        updateQuestion(_data)
          .then((res) => {
            showLoading(false);
            if (res.status) {
              validation.resetForm();
              SuccessNotify("Question updated Successfully!!!");

              if (props.closeAction) {
                props.closeAction();
              }
            } else {
              ErrorNotify(res.message);
            }
          })
          .catch((err) => {
            showLoading(false);
            console.log(err);
            ErrorNotify("failed");
          })
          .finally(() => setIsSaving(false));
      }
    },
  });

  const selectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: state.isFocused ? "#86b7fe" : "#d7e0ec",
      borderRadius: 7,
      boxShadow: state.isFocused
        ? "0 0 0 .2rem rgba(13, 110, 253, .15)"
        : "none",
      minHeight: 39,
      "&:hover": { borderColor: state.isFocused ? "#86b7fe" : "#d7e0ec" },
    }),
    valueContainer: (base) => ({ ...base, minHeight: 37, padding: "0 11px" }),
    input: (base) => ({ ...base, color: "#20375f", fontSize: 13 }),
    singleValue: (base) => ({ ...base, color: "#20375f", fontSize: 13 }),
    placeholder: (base) => ({ ...base, color: "#6c7a91", fontSize: 13 }),
    menuPortal: (base) => ({ ...base, zIndex: 1080 }),
  };

  const selectOptions = (items, label) =>
    (items || []).map((item) => ({ value: item.id, label: label(item) }));

  const selectedOption = (options, value) =>
    options.find((option) => String(option.value) === String(value)) || null;

  const areaOptions = selectOptions(areaList, (area) => area.name);
  const topicOptions = selectOptions(topicList, (topic) => topic.name);
  const serviceCodeOptions = selectOptions(
    serviceCodeList,
    serviceCodeOptionLabel
  );
  const mandatoryServiceCodeOptions = selectOptions(
    mandatoryServiceCodeList,
    serviceCodeOptionLabel
  );

  return (
    <Fragment>
      <Form
        className="needs-validation checklist-question-form"
        onSubmit={(e) => {
          e.preventDefault();
          addAnother.current = e.nativeEvent.submitter?.value === "another";
          validation.handleSubmit();
          return false;
        }}
      >
        <div className="checklist-question-form__body">
          {savedReference && <p role="status">Saved {savedReference}. Classifications retained for the next question.</p>}
          <Row>
            <Col sm="12" className="mb-1">
              <Label className="form-label" for="input-default">
                Checklist Question
              </Label>
              <Input
                type="textarea"
                innerRef={questionInput}
                autoFocus
                name="name"
                placeholder="Enter the checklist question"
                className="form-control"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.name || ""}
                invalid={
                  validation.touched.name && validation.errors.name
                    ? true
                    : false
                }
              />
              {validation.touched.name && validation.errors.name ? (
                <FormFeedback type="invalid">
                  {validation.errors.name}
                </FormFeedback>
              ) : null}
            </Col>

            {formData.id ? <Col sm="12" className="mb-1">
              <Label className="form-label" for="input-default">
                Reference Number
              </Label>
              <Input
                type="text"
                name="referenceNo"
                placeholder="Checklist Reference Number"
                className="form-control"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.referenceNo || ""}
                invalid={
                  validation.touched.referenceNo &&
                  validation.errors.referenceNo
                    ? true
                    : false
                }
              />
              {validation.touched.referenceNo &&
              validation.errors.referenceNo ? (
                <FormFeedback type="invalid">
                  {validation.errors.referenceNo}
                </FormFeedback>
              ) : null}
            </Col> : <Col sm="12"><p>Reference number: Assigned automatically on save</p></Col>}

            <Col sm="12" className="mb-1">
              <Label className="form-label" for="areaId">
                Area
              </Label>
              <SearchableSelect
                validation={validation}
                selectStyles={selectStyles}
                field="areaId"
                options={areaOptions}
                placeholder="Search and select area"
              />
              {validation.touched.areaId && validation.errors.areaId ? (
                <FormFeedback type="invalid">
                  {validation.errors.areaId}
                </FormFeedback>
              ) : null}
            </Col>

            <Col sm="12" className="mb-1">
              <Label className="form-label" for="topicId">
                Topic
              </Label>
              <SearchableSelect
                validation={validation}
                selectStyles={selectStyles}
                field="topicId"
                options={topicOptions}
                placeholder="Search and select topic"
              />
              {validation.touched.topicId && validation.errors.topicId ? (
                <FormFeedback type="invalid">
                  {validation.errors.topicId}
                </FormFeedback>
              ) : null}
            </Col>

            <Col sm="12" className="mb-1">
              <Label className="form-label" for="serviceCodeId">
                PRIMA Service Code
              </Label>
              <SearchableSelect
                validation={validation}
                selectStyles={selectStyles}
                field="serviceCodeId"
                options={serviceCodeOptions}
                placeholder="Search and select service code"
              />
              {validation.touched.serviceCodeId &&
              validation.errors.serviceCodeId ? (
                <FormFeedback type="invalid">
                  {validation.errors.serviceCodeId}
                </FormFeedback>
              ) : null}
            </Col>

            <Col sm="12" className="mb-1">
              <Label className="form-label" for="mustServiceCodeId">
                PRIMA Must Service Code
              </Label>
              <SearchableSelect
                validation={validation}
                selectStyles={selectStyles}
                field="mustServiceCodeId"
                options={mandatoryServiceCodeOptions}
                placeholder="Search and select must service code"
              />
              {validation.touched.mustServiceCodeId &&
              validation.errors.mustServiceCodeId ? (
                <FormFeedback type="invalid">
                  {validation.errors.mustServiceCodeId}
                </FormFeedback>
              ) : null}
            </Col>

            <Col sm="12" className="mb-4">
              <Label className="form-label" for="description">
                Description
              </Label>
              <Input
                type="textarea"
                className="form-control"
                value={validation.values.description || ""}
                name="description"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                placeholder="Description"
              />
            </Col>
          </Row>
        </div>
        <div className="checklist-question-form__actions">
          <Button color="primary" type="submit" value="close" disabled={isSaving}>
            {isSaving ? "Saving..." : "Save"}
          </Button>
          {!formData.id && <Button color="primary" outline type="submit" value="another" disabled={isSaving}>
            Save &amp; add another
          </Button>}
          <Button color="light" type="button" onClick={props.closeAction}>
            Close
          </Button>
        </div>
      </Form>
    </Fragment>
  );
};

export default QuestionDetail;
